import {createContext, useContext} from 'react';
import {EntityContextType} from './types';

// Create Context
export const EntityContext = createContext<EntityContextType>({} as EntityContextType);

// Encapsulated context hook
export const useEntity = () => useContext(EntityContext);
